<template>
    <div class="p-3">
        <h3>RL 3.14 Kegiatan Pelayanan Khusus</h3>
        <hr>
        <DataTable table-id="table-pasien" title="Kegiatan Pelayanan Khusus" :filter-configs="filterConfigs"
            :table-options="tableOptions" :show-filter="true" />
    </div>
</template>

<script>
import DataTable from '@/components/global/DataTable.vue'

export default {
    components: {
        DataTable
    },
    data() {
        return {
            filterConfigs: [
                {
                    id: 'year',
                    label: 'Tahun',
                    field: 'year',
                    type: 'year',
                    colClass: 'col-sm-3',
                    component: 'DropDownYear'
                }
            ],
            tableOptions: {
                baseUrl: '/api/rekapitulasi-pelayanan/kegiatan-pelayanan-khusus',
                layout: 'fitDataStretch',
                responsiveLayout: 'collapse',
                columnMinWidth: 80,
                columns: [
                    {
                        title: "No.",
                        field: "no",
                        hozAlign: "center",

                    },
                    {
                        title: "Jenis Kegiatan",
                        field: "jenis_kegiatan",
                    },
                    {
                        title: "Jumlah",
                        field: "jumlah",
                        hozAlign: "center",
                    }
                ],
                ajaxResponse: (url, params, response) => response
            }
        }
    },
}
</script>
